import Filters from '@/utils/input/filters';
import { registerModuleFilters } from '@/utils/input/filters';

const ProcessFilter = {
  ...Filters.ProcessFilter,
  name: 'processId',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  name: 'created',
  label: 'global.created',
};

const UserCreatorFilter = {
  ...Filters.UserFilter,
  name: 'userCreatorId',
  label: 'global.userCreator',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  name: 'updated',
  label: 'global.updated',
};

const UserModifierFilter = {
  ...Filters.UserFilter,
  name: 'userModifierId',
  label: 'global.userModifier',
};

export const filtersConfig = [
  ProcessFilter,
  CreatedDateFilter,
  UserCreatorFilter,
  UpdatedDateFilter,
  UserModifierFilter,
];

const SubSequenceCreatedDateFilter = {
  ...Filters.DateFilter,
  name: 'created',
  label: 'global.created',
};

const SubSequenceUpdatedDateFilter = {
  ...Filters.DateFilter,
  name: 'updated',
  label: 'global.updated',
};

export const subSequenceFiltersConfig = [
  SubSequenceCreatedDateFilter,
  SubSequenceUpdatedDateFilter,
];

registerModuleFilters('sequences', filtersConfig);
registerModuleFilters('subSequence', subSequenceFiltersConfig);
